const getEnvValue = (key, defaultValue) => {
  if (window._env_ && window._env_[key]) {
    return window._env_[key];
  }
  return process.env[key] || defaultValue;
};

export const API_BASE_URL = getEnvValue(
  'REACT_APP_API_URL',
  'https://lexai-api-74624883720.us-central1.run.app'
);

export const APP_VERSION = getEnvValue('REACT_APP_VERSION', 'v2');

export const COMMUNICATOR_BASE_URL = getEnvValue(
  'REACT_APP_COMMUNICATOR_URL',
  'https://insureai-communicator-1074099157700.us-central1.run.app'
);

export const CHAT_URL = getEnvValue(
  'REACT_APP_CHAT_URL',
  'https://bot-74624883720.us-central1.run.app'
);

export const COMPANY_ANALYSIS_URL = getEnvValue(
  'REACT_APP_COMPANY_ANALYSIS_URL',
  'https://company-analysis-74624883720.us-central1.run.app'
);

export const WEB_SCRAPING_URL = getEnvValue(
  'REACT_APP_WEB_SCRAPING_URL',
  'https://cipilot-web-scrapper-318242574572.us-central1.run.app'
);

console.log('REACT_APP_API_URL:', API_BASE_URL);
console.log('REACT_APP_VERSION:', APP_VERSION);
console.log('REACT_APP_COMMUNICATOR_URL:', COMMUNICATOR_BASE_URL);
console.log('REACT_APP_CHAT_URL:', CHAT_URL);
console.log('REACT_APP_COMPANY_ANALYSIS_URL:', COMPANY_ANALYSIS_URL);
console.log('REACT_APP_WEB_SCRAPING_URL:', WEB_SCRAPING_URL);
